import useCleanPassengerClassToPassengersMapping
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/hooks/useCleanPassengerClassToPassengersMapping";
import PassengersInAClassGroupList
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/components/PassengersInAClassGroupList";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

interface PassengerClassSelectModalContentProps {
    closeModal: () => void,
    passengerId: number,
    selectedPassengerClass: AvailablePassengerClassType | undefined,
    setSelectedPassengerClass: (passengerClass: AvailablePassengerClassType, passengerGroupIndex?: number) => void,
    isReturn: boolean,
}

function PassengerClassSelectModalContent(props: PassengerClassSelectModalContentProps) {
    const {
        closeModal,
        passengerId,
        selectedPassengerClass,
        setSelectedPassengerClass,
        isReturn,
    } = props

    const passengerClassToPassengerMapping = useCleanPassengerClassToPassengersMapping(
        passengerId,
        selectedPassengerClass,
        isReturn
    )

    const addUserToThisPassengerGroup = (index: number) => () => {
        setSelectedPassengerClass(selectedPassengerClass, index)
        closeModal()
    }

    return (
        <>
            {passengerClassToPassengerMapping?.map((passengerIdsGroup, index) => (
                <PassengersInAClassGroupList
                    key={passengerIdsGroup[0]}
                    passengerIdsGroup={passengerIdsGroup}
                    selectedPassengerClass={selectedPassengerClass}
                    addUserToThisPassengerGroup={addUserToThisPassengerGroup}
                    index={index}
                    isReturn={isReturn}
                />
            ))}
        </>
    )
}

export default PassengerClassSelectModalContent